import { Address } from "@app/address/model/address";
import { DbCrudHelper, RowsAffected } from "@app/shared/services/db-crud-helper";
import { catchError } from "rxjs/operators";
import { ClareSystem, ClareSystemData, ClareSystemHelper, Project, SecuritySystem } from "../model";

import { Injectable } from "@angular/core";
import { ClareWSCrudHelperService } from "@app/shared/services/clare-ws-crud-helper.service";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";
import { Observable, of } from "rxjs";

export interface ProjectAndRelated {
    address: Address;
    clareSystem: ClareSystem;
    project: Project;
    securitysystem: SecuritySystem | null;
}

@Injectable({
    providedIn: "root",
})
export class ClareSystemDbService {
    helper = new ClareSystemHelper();
    crudHelperService: ClareWSCrudHelperService<ClareSystem, ClareSystemData>;
    constructor(protected tsLoggingService: TSLoggingService, protected crudHelper: DbCrudHelper) {
        this.crudHelperService = new ClareWSCrudHelperService(tsLoggingService, crudHelper, this.helper);
    }

    getProjectIdByUuid(uuid: string): Observable<number | null> {
        if (!uuid) {
            return of(null);
        }
        return this.crudHelper
            .makeRequest<number>("GetProjectIDByUUID", { uuid })
            .pipe(this.crudHelper.returnNullIfNotFound(), catchError(DataServiceError.handleError()));
    }

    getClareSystemByUuid(uuid: string, errorsToSuppress: string[] = []): Observable<ClareSystemData | null> {
        if (!uuid) {
            return of(null);
        }
        return this.crudHelperService.retrieveSingle({
            endpoint: "GetClaresystemByUUID",
            data: { uuid },
            errorsToSuppress,
        });
    }

    updateClareSystem(clareSystem: ClareSystem): Observable<RowsAffected> {
        if (!clareSystem?.id) {
            console.error("Invalid claresystem", clareSystem);
            throw new Error("Invalid claresystem");
        }

        if (clareSystem.macAddress) {
            clareSystem.macAddress = clareSystem.macAddress.toUpperCase();
        }

        return this.crudHelperService.update({
            endpoint: "UpdateClaresystem",
            data: clareSystem,
            logData: { clareSystem },
        });
    }
}
